import type { OngoingRequestsController } from "./types/OngoingRequestsController";

export const makeOngoingRequestsControllers =
  (): OngoingRequestsController => ({});
